// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/paper-dashboard.scss
// module id = MAOu
// module chunks = 6